import { render, staticRenderFns } from "./UserFavouriteProductDetail.vue?vue&type=template&id=12913703&scoped=true"
import script from "./UserFavouriteProductDetail.vue?vue&type=script&lang=js"
export * from "./UserFavouriteProductDetail.vue?vue&type=script&lang=js"
import style0 from "./UserFavouriteProductDetail.vue?vue&type=style&index=0&id=12913703&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12913703",
  null
  
)

export default component.exports